import { RadioGroup } from '@tribeplatform/react-ui-kit/RadioGroup'

import {
  TypographyTheme,
  typographyThemes,
} from '../../../themes/typography/themes'
import { ActionKind } from '../../CanaryPageBuilder/types'
import { useThemePreviewContext } from './ThemePreviewContext'

export const Typography = () => {
  const {
    state: { theme },
    dispatch,
  } = useThemePreviewContext()

  const { typography } = theme
  const { theme: typographyTheme } = typography

  const setFontFamily = (typographyTheme: TypographyTheme) => {
    dispatch({
      type: ActionKind.SetTheme,
      payload: {
        typography: {
          theme: typographyTheme,
        },
      },
    })
  }

  return (
    <div className="space-y-5">
      <RadioGroup value={typographyTheme} onChange={setFontFamily}>
        <RadioGroup.Items>
          {Object.keys(typographyThemes).map(key => (
            <RadioGroup.Item
              key={key}
              value={key}
              title={typographyThemes[key].title}
            />
          ))}
        </RadioGroup.Items>
      </RadioGroup>
    </div>
  )
}
